export const consentCookiesOptions = {
  props: ({mutate}) => ({
    consentCookiesMutation: variables => {
      return mutate({
        variables
      });
    }
  })
};
